import * as React from "react";
import styled from "styled-components";

import i18n from "../../lib/i18n";
import { Project, Company } from "../entities";
import { media } from "../../common/utils/style";
import { NavigatableSection, SectionInner, SectionTitle, SectionLink } from "./Section";
import { navFullPath } from "./HeaderNav";
import Translate from "../../common/components/Translate";
import Carousel from "../../common/components/Carousel";
import StartActionCard from "./StartActionCard";
import ProjectCardSimple from "../../projects/components/ProjectCardSimple";

interface Props {
  company: Company;
  projects: Project[];
  editable?: boolean;
  locale: string;
}

const ProjectsSection: React.SFC<Props> = props => {
  const { company, projects, editable, locale } = props;
  const hasContent = projects.length > 0;
  if (!editable && !hasContent) {
    return null;
  }
  return (
    <NavigatableSectionExtended
      id="projects"
      displayName={i18n.translate("company.home.sections.projects", { locale })}
    >
      <SectionInner>
        <SectionTitle>
          <Translate id="company.home.sections.projects" />
          <SectionLink to={navFullPath(company, "/projects")}>
            <Translate id="company.home.view_other_projects" />
          </SectionLink>
        </SectionTitle>
      </SectionInner>
      {editable &&
        !hasContent && (
          <StartActionCard
            message={i18n.translate("company.home.start_projects_card.message", { locale })}
            subMessage={i18n.translate("company.home.start_projects_card.sub_message", { locale })}
            buttonText={i18n.translate("company.home.start_projects_card.button_text", { locale })}
            linkPath="/enterprise/projects/new"
          />
        )}
      {hasContent && (
        <SliderWrapper>
          <CarouselWrapper>
            <Carousel
              layouts={{
                small: { perPage: 1.5, gutter: 16 },
                medium: { perPage: 2.5, gutter: 16 },
                large: { perPage: 3, gutter: 21 },
              }}
              childCount={projects.length}
              renderChild={index => {
                const project = projects[index];
                return <Card key={project.id} project={project} company={company} />;
              }}
            />
          </CarouselWrapper>
        </SliderWrapper>
      )}
    </NavigatableSectionExtended>
  );
};

const NavigatableSectionExtended = NavigatableSection.extend`
  @media ${media.large} {
    margin: 120px auto 0;
  }
`;

const Card = styled(ProjectCardSimple)`
  display: block;
`;

const SliderWrapper = styled.div`
  overflow-x: hidden;
`;

const CarouselWrapper = styled(SectionInner)`
  margin: 0 30px 0 16px;
  @media ${media.large} {
    margin: 0 auto;
  }
`;

export default ProjectsSection;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ProjectsSection.tsx